<template>
<div>
    <fieldset>
        <legend :class="$style.editContentLegendTitle"><b>{{target.substring(0, 1).toUpperCase() + target.substring(1)}}</b></legend>

        <template v-for="language in languages">
            <div :class="$style.input_container" :key="question.config.id+'_header_' +language.code">
                <div :class="$style.editContentEditorSection">
                    <p>Language: <b><u>{{language.name}}</u></b></p>
                    <editor
                        v-model="content[language.code]"
                        api-key="vjwto0uux6l25qp5q562n4506qp5s5s615aruwxt2x4m5mt5"
                        :init="editorInit"
                    /> 
                </div>
                <div :class="$style.editContentPreviewSection">
                    <p>Preview</p>
                    <fieldset v-html="content[language.code]">
                    </fieldset>
                </div>
            </div>
        </template>
    </fieldset>
</div>
</template>

<script>
import EditorLabelSet from '@/components/Survey/helpers/EditorLanguageLabel.js';
import Editor from '@tinymce/tinymce-vue'

export default {
    name: 'content-editor',
    props: {
        target: {
            type: String,
            required: true
        },
        question: {
            type: Object,
            required: true
        },
        languages: {
            type: Array,
            required: true
        },
        question_type: {
            type: String,
            required: false
        }
    },
    components: {
        'editor': Editor
    },
    created: function(){
        let content = JSON.stringify(this.question.config[this.target]);
        content = JSON.parse(content);
        if(typeof content=='string' || content.length===0){
            content = {};
        }
        this.content = content;
        
        this.autoSetContent();
    },
    data: function(){
        return {
            content: {},
            editorInit: {
                placeholder: 'One input per line',
                height: 200,
                menubar: false,
                plugins: ['lists', 'paste', 'image'],
                toolbar:
                'formatselect | bold italic underline| \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | superscript subscript | paste | \
                link image',
                paste_as_text: true,
                image_title: false,
                file_picker_types: 'image',
                file_picker_callback: function (cb, value, meta) {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'image/*');

                    /*
                    Note: In modern browsers input[type="file"] is functional without
                    even adding it to the DOM, but that might not be the case in some older
                    or quirky browsers like IE, so you might want to add it to the DOM
                    just in case, and visually hide it. And do not forget do remove it
                    once you do not need it anymore.
                    */

                    input.onchange = function () {
                    var file = this.files[0];

                    var reader = new FileReader();
                    reader.onload = function () {
                        /*
                        Note: Now we need to register the blob in TinyMCEs image blob
                        registry. In the next release this part hopefully won't be
                        necessary, as we are looking to handle it internally.
                        */
                        var id = 'blobid' + (new Date()).getTime();
                        var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = reader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);

                        /* call the callback and populate the Title field with the file name */
                        cb(blobInfo.blobUri(), { title: file.name });
                    };
                    reader.readAsDataURL(file);
                    };

                    input.click();
                }
            }
        }
    },
    methods: {
        setDefault: function(target, question_type, language){
            let output = EditorLabelSet[target]!==undefined && EditorLabelSet[target][question_type]!==undefined ?
                    EditorLabelSet[target][question_type][language]!==undefined ? EditorLabelSet[target][question_type][language] : EditorLabelSet[target][question_type].default
                    : null;
            if (output!==null && target==='subtext'){
                let matches = output.match(/\d+/g);
                if (matches){
                    for(let i=0; i<matches.length; i++){
                        output = output.replace(matches[i], i==0 ? this.question.config.min_num_picks 
                            : this.question.config.max_num_picks!=0 ? this.question.config.max_num_picks : this.question.config.groups[0].inputs.length);
                    }
                }
            }
            
            return target === 'subtext' && output!==null ? "<i>" + output + "</i>" : output;
        },
        autoSetContent: function(resetDefault=false){
            let autoSet = false;
            for(let l=0; l<this.languages.length; l++){
                let language = this.languages[l];
                if (!this.content[language.code] || resetDefault===true){
                    this.content[language.code] = this.setDefault(this.target, this.question.config.type ,language.code);
                    autoSet = true;
                }
            }
        },
    },
    computed: {
        
    },
    watch: {
        content: {
            deep: true,
            handler: function(){
                this.$emit('update',{
                    target: this.target,
                    content: this.content,
                    question_id: this.question.config.id
                })
            }
        },
        question_type: function(after, before){
            if (after && after!==before){
                this.autoSetContent(true);
            }
        },
        question: {
            deep: true,
            handler: function(after, before){
                if (after!==undefined && this.target==='subtext'){
                    if (EditorLabelSet[this.target]!==undefined && EditorLabelSet[this.target][after.config.type]!==undefined){
                        let systemDefaultSubtextClean = EditorLabelSet[this.target][after.config.type].default.replace(/[0-9]/g, ''); //remove digits placeholder from system default subtext if applied
                        let inEditorSubtextClean = after.config.subtext.en.replace(/[0-9]/g, '').replace( /(<([^>]+)>)/ig, ''); //remove digits and html tags from subtext on spot in survey editor if applied
                        if (systemDefaultSubtextClean==inEditorSubtextClean){
                            this.autoSetContent(true);
                        }
                        else {
                            return this.customCLog("Subtext Customized/Changed from System recommended default");
                        }
                    }
                }
            }
        }
    }
}
</script>

<style module>
.input_container{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: center;
}

.editContentEditorSection {
    width: 60%;
}

.editContentPreviewSection {
    width: 40%;
}

.editContentLegendTItle {
    padding: 0 10px; 
    font-size: 1.2rem;
}
</style>